import { PrettyCurrency, Typography } from 'components';
import { useTranslations } from 'next-intl';
import { useBalance } from 'providers/InvoicesProviders/useBalance';
import { useConfig } from 'providers/InvoicesProviders/useConfig';

export default function Totals({
  invoice: { amount, netAmount, taxAmount, currency, paymentMethod }
}) {
  const t = useTranslations();

  const { data: balance } = useBalance();
  const { data: config } = useConfig();

  return (
    <>
      <div className="mb-6 flex justify-end">
        <table id="totals" className="invoice__new_totals table--clean w-50 table">
          <tbody>
            <tr className="!border-0 !border-b-1 border-dashed !border-b-tertiary-600">
              <th className="font-size-print">
                <Typography variant="medium5" className="text-tertiary-100">
                  {t('invoices.index.transactions.ex_tax')}
                </Typography>
              </th>
              <td className="font-size-print !border-0">
                <PrettyCurrency currency={currency} amount={netAmount} />
              </td>
            </tr>
            <tr className="!border-0 !border-b-1 border-dashed !border-b-tertiary-600">
              <th className="font-size-print">
                <Typography variant="medium5" className="text-tertiary-100">
                  {t('invoices.index.transactions.tax_amount')}
                </Typography>
              </th>
              <td className="font-size-print !border-0">
                <PrettyCurrency currency={currency} amount={taxAmount} />
              </td>
            </tr>
            <tr>
              <th className="font-size-print--big">
                <Typography variant="medium4" className="text-tertiary-100">
                  {t('invoices.totals.total')}
                </Typography>
              </th>
              <td className="font-size-print--big !border-0 !text-primary-blue-100">
                <PrettyCurrency currency={currency} amount={amount} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {paymentMethod != 'credit_card' && (
        <>
          <br />
          <br />
          {balance && (
            <Typography variant="regular4" className="font-size-print">
              {t('billing.invoice_items.explanation1', {
                numberOfDays: balance?.invoiceDueDays || 14
              })}
            </Typography>
          )}
          <br />
          <Typography variant="regular4" className="font-size-print">
            BIC/SWIFT: {config?.bic}.
            {t('billing.invoice_items.explanation2', { bank_account: config?.iban })}
          </Typography>
        </>
      )}
    </>
  );
}
